import { Outlet, useLocation } from 'react-router-dom';
import { usePavilion } from '../contexts/PavilionContext';
import { Header } from './Header';
import { AidaHeader } from './aida/AidaHeader';
import { AidaFooter } from './aida/AidaFooter';
import { Community } from './Community';
import { WhyPlaycast } from './WhyPlaycast';
import { CookieManager } from './CookieManager';
import { Footer } from '@playcastdotio/Footer';
import '../../styles/aida-base.css';
import { useEffect } from 'react';

export const Content = () => {
  const location = useLocation();
  const { isPavilionMode } = usePavilion();

  const pathname = location.pathname.replace(/\/+$/, '') || '/';

  const isProfilePage = /^\/(p|pt|pd)\//.test(location.pathname);
  const isHomePage = pathname === '/';
  const isHostHelldiversPage = pathname === '/host/helldivers-ii';
  const isHostSteamCardPage = pathname === '/host/steam-card';
  const isHostOutbreakPage = pathname === '/host/outbreak';
  const isGameGalleryPage = pathname === '/gamegallery';
  const isNonsoleModePage = pathname === '/nonsole-mode';
  const isHostsPage = pathname === '/hosts';
  const isDevelopersPage = pathname === '/developers';
  const isAboutPage = pathname === '/about';
  const isServicesAgreementPage = pathname === '/services-agreement';

  // Enable Aida components - set to true to use new design
  const useAidaDesign = !isPavilionMode; // Use Aida design for non-pavilion mode

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  // Add/remove class to body to control Aida styles - for home page and host pages
  useEffect(() => {
    if ((isHomePage || isHostsPage || isDevelopersPage || isHostHelldiversPage || isHostSteamCardPage || isHostOutbreakPage || isGameGalleryPage || isNonsoleModePage || isAboutPage || isServicesAgreementPage) && useAidaDesign) {
      document.body.classList.add('aida-home-page');
    } else {
      document.body.classList.remove('aida-home-page');
    }

    return () => {
      document.body.classList.remove('aida-home-page');
    };
  }, [isHomePage, isHostsPage, isDevelopersPage, isHostHelldiversPage, isHostSteamCardPage, isHostOutbreakPage, isGameGalleryPage, isNonsoleModePage, isAboutPage, isServicesAgreementPage, useAidaDesign, location.pathname]);

  return (
    <div className={`relative ${useAidaDesign ? '' : 'flex h-screen min-h-screen flex-col overflow-hidden'} ${isPavilionMode ? 'pavilion-mode' : ''}`}>
      <CookieManager>
        {['/io', '/jo', '/j/', '/q/'].includes(location.pathname.substring(0, 3)) || location.pathname.includes('stf-attribution') ? (
          <Outlet />
        ) : (
          <>
            {useAidaDesign ? <AidaHeader /> : <Header />}
            <div data-testid='outlet' className={`${useAidaDesign ? '' : 'flex flex-1 flex-col overflow-y-auto'}`}>
              <Outlet />
              {isProfilePage ? (
                ''
              ) : ['/ux', '/di'].includes(location.pathname.substring(0, 3)) ? (
                <WhyPlaycast />
              ) : !useAidaDesign ? (
                <Community />
              ) : null}
              {isProfilePage ? '' : useAidaDesign && !isHomePage ? <AidaFooter /> : !useAidaDesign ? <Footer isPavilionMode={isPavilionMode} /> : null}
            </div>
          </>
        )}
      </CookieManager>
    </div>
  );
};
